import React, { useState, useEffect } from "react";
import { NotifFromGrafferType } from "../application/domain/notifi-from-graffer/notif-from-graffer";
import { GrafferNotifService } from "../application/domain/notifi-from-graffer/notif-from-graffer-service";

export const useNotifFromGrafferPage = () => {
  const [notifs, setNotifs] = useState<NotifFromGrafferType[]>([]);
  const [currentPage] = useState(0);

  const fetchListByPage = React.useCallback(
    async (page: number | undefined) => {
      const data = await GrafferNotifService.fetchPage(page);
      setNotifs(data[0]);
    },
    [setNotifs],
  );

  useEffect(() => {
    fetchListByPage(currentPage);
  }, [fetchListByPage, currentPage]);

  return notifs;
};
